// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"54a60332","537":"3c1aa7dc","548":"eea4b3a3","837":"f4478188","850":"b5356d09","889":"9e81b445"}[chunkId] + ".css";
};